import { useRequest } from 'ahooks'
import { toJS } from 'mobx'
import { useEffect } from 'react'

import warningMsg from '@/components/NewEditForm/UILibrary/HYBElement/AlertDialog'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import { personnelDetails, saveSocialSecurityAdjust, deleteSocialSecurityAdjust } from './service'

export default ({ value, staff_Id, staffDetail, socialUserInfos, setState, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  useEffect(() => {
    // detailsOk()
    setState({
      staffDetail: value || {},
      socialUserInfos: value?.social_security_adjust_results || []
    })
  }, [staff_Id, value])
  // // 人员信息详情查询
  // const detailsOk = () => {
  //   runPersonnelDetails(staff_Id)
  // }
  // // 人员信息详情
  // const { run: runPersonnelDetails } = useRequest(personnelDetails, {
  //   manual: true,
  //   onSuccess: (result: any) => {
  //     const { data, code } = result
  //     if (code === 2000) {
  //       setState({
  //         staffDetail: data || {},
  //         socialUserInfos: data?.social_security_adjust_results || []
  //       })
  //     }
  //   },
  //   onError: ({ message }) => {
  //     console.log('error', message)
  //     setState({ staffDetail: {}, socialUserInfos: [] })
  //   }
  // })

  const add = () => {
    onOpen({
      status: 'Add',
      editItem: {
        employee_name: staffDetail?.base_map?.name || null,
        social_security_status: staffDetail?.salary_card_map?.social_security_status || null,
        social_security_cardinality:
          staffDetail?.salary_card_map?.social_security_cardinality || null,
        provident_fund_status: staffDetail?.salary_card_map?.provident_fund_status || null,
        provident_fund_cardinality: staffDetail?.salary_card_map?.provident_fund_cardinality || null
      }
    })
  }

  const edit = (index: number) => {
    const record = socialUserInfos?.[index] || {}
    const values_ = {
      ...record,
      employee_name: staffDetail?.base_map?.name || null,
      social_security_status: staffDetail?.salary_card_map?.social_security_status || null,
      provident_fund_status: staffDetail?.salary_card_map?.provident_fund_status || null
    }
    onOpen({ status: 'Edit', editItem: values_ })
  }
  // 调整记录 添加/编辑
  const { run: runSaveSocialSecurityAdjust, loading: saveSocialSecurityAdjustLoading } = useRequest(
    saveSocialSecurityAdjust,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code, data } = result
        if (code === 2000 && !data?.length) {
          onCancel()
          onConfirm()
        } else if (data && data?.length > 0) {
          onConfirm()
          onCancel()
          return warningMsg({
            title: '操作失败',
            data,
            text: '{employee_name} {employee_no}',
            msg: 'reason'
          })
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )

  // 调整记录 批量删除
  const { run: runDeleteSocialSecurityAdjust, loading: deleteSocialSecurityAdjustLoading } =
    useRequest(deleteSocialSecurityAdjust, {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    })

  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runSaveSocialSecurityAdjust,
    runDeleteSocialSecurityAdjust,
    saveSocialSecurityAdjustLoading,
    deleteSocialSecurityAdjustLoading
  }
}
